import * as _ from 'underscore';

import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { UniqueReachAndFrequencyComponent } from '../unique-reach-and-frequency/unique-reach-and-frequency.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
@Component({
	selector: 'app-unique-reach-and-frequency-r13',
	styleUrls: ['./unique-reach-and-frequency-r13.component.css'],
	templateUrl: './unique-reach-and-frequency-r13.component.html'
})
export class UniqueReachAndFrequencyR13Component extends UniqueReachAndFrequencyComponent implements OnInit {
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	changeCampaignData(campaign: object): void {
		const selectedIndex = this.campaignsList.findIndex((creativeObj) => {
			return creativeObj.name === campaign['name'];
		});
		this.moveToSelected(selectedIndex);
	}

	moveToSelected(index: number): void {
		this.currentIndex = index;
		this.displayIndex = index;
		this.campaignCarouselItem = this.campaignsList[this.displayIndex];
	}

	// toggle series visible
	toggleSeriesVisiblityByCheckbox(id: string): void {
		this.seriesviewconfiguration.checkboxButtons.forEach((checkboxButton) => {
			checkboxButton.visible = checkboxButton.seriesId === id ? !checkboxButton.visible : checkboxButton.visible;
		});
		this.campaignCarouselItem.graphData.forEach((series: any) => {
			if (id.toUpperCase() === series.id.toUpperCase()) {
				series['visible'] = !series.visible;
			}
		});
		this.campaignCarouselItem = { ...this.campaignCarouselItem };
	}

	// updating chart series visible flag to false on radio selection
	updateSeriesVisibilityByRadioButton(radioButtonId: any): void {
		this.selectedRadioButtonId = parseInt(radioButtonId, 10);
		this.seriesviewconfiguration.radioButtonGroup.forEach((radioButtonConfig, index) => {
			this.campaignCarouselItem.graphData.forEach(function (seriesConfig): void {
				if (radioButtonConfig.seriesId === seriesConfig['id']) {
					seriesConfig['visible'] = parseInt(radioButtonId, 10) === parseInt(index, 10);
				}
			});
		});
		this.campaignCarouselItem = { ...this.campaignCarouselItem };
	}

	public toolTipFormatter = {
		formatter(): any {
			const yVal = this.series.name.toLowerCase().includes('uniques')
				? this.point.y.toLocaleString()
				: this.point.y.toLocaleString() + 'x';
			return `<div class="toolTipClass">
									<table >
										<tr class="tooltipRow">
											<td class="tooltipRow">date</td>
											<td class="tooltipDate tooltipRow">${moment(this.x).format('MMM D, YYYY')}</td>
										</tr>
										<tr><td class="tooltipRow" style="color: ${this.color} !important">${
				this.series.name
			}</td><td class="tooltipRow" style="color: ${this.color} !important">${yVal} </td></tr>
									</table>
								</div>`;
		}
	};

	getXaxisConfigForEachCampaign(categories: any[]): {} {
		this.customchartconfiguration.graphConfig.xAxis.labels = {
			...this.customchartconfiguration.graphConfig.xAxis.labels,
			...{
				formatter(): any {
					this.value = this.value.split(',')[0];
					return `<span class='xlabel'> ${this.value} </span>`;
				}
			}
		};

		return {
			...this.customchartconfiguration.graphConfig.xAxis,
			...{ categories }
		};
	}
}
